import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ApiService} from '../../services/api.service';
import {UserService} from '../../services/user.service'; 
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public email: string;
  public password: string;
  public loginStatus = 0;
  public loginError = "";

  constructor(
    private apiSvc: ApiService,
  private userSvc: UserService,
private router: Router) { }

  ngOnInit() { 
    this.loginError = "";
    this.loginStatus = 0;
  }
        // LoginStatus
        // 0 = Normal
        // 1 = Connecting

        public postLogin() {
          this.loginStatus = 1;
          this.loginError = "";

          var payload: PayloadParams[] = [];
          payload.push({ key: "username", value: this.email});
          payload.push({ key: "password", value: this.password});
          payload.push({ key: "grant_type", value: "password"});

          var body = this.encodeParams(payload);

          var headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded"
          }); 

          var response = this.apiSvc.post<any>("token", body, headers);

          response.subscribe(
              data => {
                this.userSvc.setUserName(data.userName);
                this.apiSvc.setToken(data.access_token);

                // TODO Find a better way to do this
                if (data.admin === "true" ) {
                  this.userSvc.isAdmin = true;
                } else {
                  this.userSvc.isAdmin = false;
                }

                console.clear();
                console.log(data.admin);

                 this.router.navigate(["/"]);
                // this.router.navigate(['/calendar-year/2017']);
              },
              err => {
                console.log(err);
                this.loginStatus = 0;
                this.loginError = null;

                if (err._body) {
                  console.log(err._body);
                  this.loginError = err.json().error_description;
                  console.log(this.loginError);
                }

                if (!this.loginError) {
                  this.loginError = "Unspecfied error";
                }

              }
          );

        }



    private encodeParams(params: PayloadParams[]): string {

            let body = "";
            params.forEach(element => {

              if (body.length) {
                body += "&";
              }
              body += element.key + "=";
              body += encodeURIComponent(element.value);

            });

            return body;
        }



}

class PayloadParams {
  public key: string;
  public value: any
}

